import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
import noAuthStack from 'hub-http/stacks/noAuthWithCredentialsHubapi';
export const ecosystemAppClient = promiseClient(createStack(coreMiddlewares.base('ecosystem/v1/'), appAuthStack));
export const ecosystemPublicClient = promiseClient(createStack(coreMiddlewares.base('ecosystem/public/v1/'), noAuthStack));